// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"975978d8","294":"45d12965"}[chunkId] + ".chunk.css";
};